import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.61872 8.38128C9.27701 8.03957 8.72299 8.03957 8.38128 8.38128C8.03957 8.72299 8.03957 9.27701 8.38128 9.61872L10.7626 12L8.38128 14.3813C8.03957 14.723 8.03957 15.277 8.38128 15.6187C8.72299 15.9604 9.27701 15.9604 9.61872 15.6187L12 13.2374L14.3813 15.6187C14.723 15.9604 15.277 15.9604 15.6187 15.6187C15.9604 15.277 15.9604 14.723 15.6187 14.3813L13.2374 12L15.6187 9.61872C15.9604 9.27701 15.9604 8.72299 15.6187 8.38128C15.277 8.03957 14.723 8.03957 14.3813 8.38128L12 10.7626L9.61872 8.38128Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
